import { IFormsTemplate } from '@commenda/api';
import { Button } from '@commenda/kakashi';
import { FormEditorProvider } from '@commenda/ui/form-builder/hooks/useFormEditor';
import { TemplateVersionsTable } from '@commenda/ui/form-builder/templates/TemplateVersionsTable';
import { PageHeader } from 'components/LayoutComponents/PageHeader';
import { AffiliateConsolePage } from 'components/Layouts/AffiliateConsolePage';
import { useRouter } from 'next/router';
import { AffiliateFormHelper } from './affiliate-form-helper';

const VersionsContent = ({
  firmId,
  templateName,
}: {
  firmId: string;
  templateName: string;
}) => {
  const router = useRouter();
  const listHref = AffiliateFormHelper.getFormsListHref(firmId);

  const openInEditor = (template: IFormsTemplate) =>
    router.push(AffiliateFormHelper.getFormEditorHref(firmId, template.id));

  return (
    <AffiliateConsolePage>
      <div className="min-h-0 flex-1 overflow-y-auto px-3xl py-2xl">
        <TemplateVersionsTable
          templateName={templateName}
          onOpenInEditor={openInEditor}
          showKeyColumn={false}
          header={
            <div className="mb-4">
              <PageHeader
                currentApp="Forms"
                pageTitle={templateName}
                onBack={() => router.push(listHref)}
                showActions={false}
              />
            </div>
          }
        />
      </div>
    </AffiliateConsolePage>
  );
};

/** Every version of one form: which is live, set another live, duplicate, delete. A row opens the
 * editor directly, unlike admin, which opens a rename modal there. */
export const AffiliateFormVersions = () => {
  const router = useRouter();
  const firmId = typeof router.query.id === 'string' ? router.query.id : '';
  const templateName =
    typeof router.query.name === 'string' ? router.query.name : '';

  if (!firmId) return null;

  if (!templateName) {
    return (
      <AffiliateConsolePage>
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4">
          <p className="txt-medium-regular text-text-tertiary">
            No form name provided.
          </p>
          <Button
            variant="secondary"
            onClick={() =>
              router.push(AffiliateFormHelper.getFormsListHref(firmId))
            }
          >
            Back to forms
          </Button>
        </div>
      </AffiliateConsolePage>
    );
  }

  return (
    <FormEditorProvider
      editorPath={AffiliateFormHelper.getFormEditorPath(firmId)}
      templatesPath={AffiliateFormHelper.getFormsListHref(firmId)}
      previewPath={AffiliateFormHelper.getFormPreviewPath(firmId)}
      storageKey={AffiliateFormHelper.getDraftStorageKey(firmId)}
      defaultDevMode={false}
      showKeyManagement={false}
    >
      <VersionsContent firmId={firmId} templateName={templateName} />
    </FormEditorProvider>
  );
};
